<template>
  <div class="card width-535">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content columns is-marginless is-multiline">
      <section class="has-text-centered column is-12">
          <span class="is-size-3 has-text-weight-bold">
            {{ $t('general.popUpEdition.title') }}
          </span>
      </section>
      <div class="column is-12 is-paddingless mgt-20px">
      <error-msg-component :messages="error.messages"
                           :error="error.haveError"
                           :title="'general.problemOccurred'"
                           :withEmplyFields="true"
                           :messagesChampsVide="error.messagesChampsVide"
                           :champsVide="error.champsVide"
                           @close="error.haveError = $event"/>
    </div>
      <div class="column is-12 is-paddingless mgt-20px" v-if="listeChoiceEdition.length > 0">
        <b-field v-for="(edition, index) in listeChoiceEdition" :key="index">
          <qd-switch v-model="edition.value">
            {{ $t(edition.libelle) }}
          </qd-switch>
        </b-field>
      </div>
      <div class="column is-12 is-paddingless mgt-20px">
        <div>
          <qd-radio v-model="format"
                   :native-value="pdf">
            {{ $t('general.popUpEdition.type.pdf') }}
          </qd-radio>
        </div>
        <div class="mgt-10px">
          <qd-radio v-model="format"
                   :native-value="docx">
            {{ $t('general.popUpEdition.type.docx') }}
          </qd-radio>
        </div>
      </div>
      <main class="column is-12 is-paddingless mgt-20px">
        <div class="has-text-centered">
          <button
            class="button btn-modal-annuler is-cancel has-text-centered
                  button-modal"
            @click="$parent.close"
            >
            {{ $t('general.popUpEdition.actions.cancel') }}
          </button>
          <button class="button is-primary has-text-centered button-modal"
            @click="valider()">
            {{ $t('general.popUpEdition.actions.valider') }}
          </button>
        </div>
      </main>
    </div>
  </div>
</template>

<script>

import { TYPE_PDF, TYPE_DOCX } from '@/configuration/edition/editionConf';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { TYPE_EDITION_ORDRE_TRAVAIL_AFFICHAGE, OT_AVEC_LAISSER_EN_PLACE } from '@/configuration/logistique/ordreTravail/ordreTravailConf';
import cloneDeep from 'lodash/cloneDeep';

export default {
  props: {
    choiceEdition: {
      type: Array,
      required: true,
    },
    error: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectEdition: null,
      format: TYPE_PDF,
      pdf: TYPE_PDF,
      docx: TYPE_DOCX,
      parametresAdditionnels: {},
      listeChoiceEdition: [],
    };
  },
  computed: {
  },
  methods: {
    valider() {
      this.parametresAdditionnels = {};
      this.listeChoiceEdition.forEach(e => {
        if (e.typeEdition && e.value) {
          this.parametresAdditionnels[e.typeEdition] = e.value;
        }
        if (e.typeEdition === OT_AVEC_LAISSER_EN_PLACE) {
          this.parametresAdditionnels[e.typeEdition] = e.value;
        }
      });
      this.$emit('editionChoose', {
        typeDonnee: TYPE_EDITION_ORDRE_TRAVAIL_AFFICHAGE,
        format: this.format,
        parametresAdditionnels: this.parametresAdditionnels,
      });
    },
  },
  components: {
    errorMsgComponent,
  },
  mounted() {
    this.listeChoiceEdition = cloneDeep(this.choiceEdition);
  },
};

</script>
